import { CreditCard, Landmark, QrCode, Banknote, FileText } from 'lucide-react';

/**
 * One icon per payment method, resolved from the key the server sends.
 *
 * The mapping lives here and nowhere else, so adding a method is a line in this
 * object rather than a conditional in three different screens (G6).
 */
const ICONS = {
  card: CreditCard,
  bank: Landmark,
  upi: QrCode,
  cash: Banknote,
  cheque: FileText,
};

export function MethodIcon({ icon, className = 'h-[18px] w-[18px]' }) {
  const Icon = ICONS[icon] ?? CreditCard;
  return <Icon className={className} aria-hidden="true" />;
}

export default MethodIcon;
